export const USERS_KEY = 'USERS_KEY';


export const buildUsersKey = () => [USERS_KEY];

export const USER_DELETE = 'USER_DELETE';
export const USER_CREATE = 'USER_CREATE';
export const USER_UPDATE = 'USER_UPDATE';